// Mock data & static content for the MusicTeam site (frontend-only teaser).
// NOTE: All content here is static/mock. The contact form saves to localStorage
// for now and will be wired to a real backend/email later.

import logo from '../assets/logo.png';

export const brand = {
  logo,
  name: 'MusicTeam',
  tagline: 'El ritmo que da vida a los espacios.',
  slogan: 'Música y entretenimiento con sentido.',
};

export const images = {
  heroStage: 'https://images.unsplash.com/photo-1571266063066-15577f80abdb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920',
  crowd: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  crowd2: 'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  stageRed: 'https://images.unsplash.com/photo-1576514129883-2f1d47a65da6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  prod1: 'https://images.pexels.com/photos/5389617/pexels-photo-5389617.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  prod2: 'https://images.pexels.com/photos/5389619/pexels-photo-5389619.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  hotel: 'https://images.unsplash.com/photo-1779764372293-d2b99883cb45?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  hotel2: 'https://images.unsplash.com/photo-1762599107234-6373d3467d25?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  stadium: 'https://images.unsplash.com/photo-1522778119026-d647f0596c20?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  stadium2: 'https://images.unsplash.com/photo-1705593973313-75de7bf95b56?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  museum: 'https://images.unsplash.com/photo-1606819717115-9159c900370b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  openair: 'https://images.pexels.com/photos/13230484/pexels-photo-13230484.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
};

export const navLinks = [
  { label: 'Encuentra tu ritmo', to: '/encuentra-tu-ritmo' },
  { label: 'Hazlo posible', to: '/hazlo-posible' },
  { label: 'En movimiento', to: '/en-movimiento' },
  { label: 'Detrás del escenario', to: '/detras-del-escenario' },
];

export const contactInfo = {
  email: 'hola@musicteam.example',
  phone: '+34 600 000 000',
  location: 'Valencia, España',
  socials: [
    { label: 'Instagram', url: '#' },
    { label: 'LinkedIn', url: '#' },
    { label: 'YouTube', url: '#' },
  ],
};

export const homeSolutions = [
  { n: '01', title: 'Música y talento artístico', text: 'Seleccionamos el formato, el estilo y los profesionales adecuados para cada proyecto.' },
  { n: '02', title: 'Producción de eventos', text: 'Planificamos y coordinamos todos los elementos necesarios para que la experiencia suceda.' },
  { n: '03', title: 'Programación de espacios', text: 'Creamos actividades puntuales, ciclos temáticos y propuestas capaces de mantener vivo un espacio todo el año.' },
  { n: '04', title: 'Activación de públicos', text: 'Diseñamos experiencias que atraen, conectan y generan nuevas razones para volver.' },
  { n: '05', title: 'Asesoramiento técnico', text: 'Aportamos criterio en sonido, equipamiento, instalaciones y funcionamiento técnico.' },
  { n: '06', title: 'Formación musical', text: 'Desarrollamos conciertos didácticos, masterclasses, cursos y proyectos pedagógicos.' },
];

export const homeSpaces = [
  { tag: '// TIPO 01', title: 'Hoteles', img: images.hotel },
  { tag: '// TIPO 02', title: 'Estadios', img: images.stadium },
  { tag: '// TIPO 03', title: 'Museos', img: images.museum },
];

export const methodSteps = [
  { n: '01', title: 'Escuchar', text: 'Entendemos el espacio, sus posibilidades, sus públicos y los objetivos del proyecto.' },
  { n: '02', title: 'Diseñar', text: 'Construimos una propuesta musical, cultural o de entretenimiento creada para ese contexto.' },
  { n: '03', title: 'Coordinar', text: 'Conectamos artistas, técnicos, proveedores, horarios, recursos y producción.' },
  { n: '04', title: 'Activar', text: 'Hacemos que todo suceda con naturalidad, precisión y capacidad de respuesta.' },
];

export const possibilities = [
  'Una programación musical que construya identidad durante todo el año.',
  'Una fan zone que forme parte de la experiencia deportiva.',
  'Un museo que también pueda recorrerse a través de la música.',
  'Un hotel donde cada encuentro tenga su propia atmósfera.',
  'Una actividad familiar capaz de conectar generaciones.',
  'Una celebración corporativa que no parezca otra celebración corporativa.',
  'Un ciclo cultural que atraiga nuevos públicos y genere comunidad.',
];

export const homeProjects = [
  { n: 'Proyecto 01', text: 'Programación cultural para un espacio público.', img: images.openair },
  { n: 'Proyecto 02', text: 'Producción musical para una experiencia corporativa.', img: images.stageRed },
  { n: 'Proyecto 03', text: 'Activación de público en un entorno deportivo.', img: images.stadium2 },
];

// ---- Encuentra tu ritmo (espacios) ----
export const spaceTypes = [
  {
    id: 'hoteles', tag: 'Más que ambientación', title: 'Hoteles', img: images.hotel,
    lead: 'Un hotel también se recuerda por lo que sucede dentro.',
    text: 'Una propuesta musical puede acompañar una llegada, transformar una terraza, crear un punto de encuentro o construir una identidad reconocible durante todo el año.',
    items: ['Música en terrazas y zonas comunes.', 'Programaciones estacionales.', 'Experiencias gastronómicas y musicales.', 'Actividades para familias.', 'Celebraciones y eventos privados.', 'Identidad musical para momentos concretos.'],
    cta: 'Encuentra el ritmo de tu hotel',
  },
  {
    id: 'museos', tag: 'Otra forma de recorrer una historia', title: 'Museos y espacios expositivos', img: images.museum,
    lead: 'Hay espacios que también pueden escucharse.',
    text: 'La música puede abrir nuevas maneras de acercarse a una exposición, un edificio o una colección. Diseñamos propuestas conectadas con el contenido, la arquitectura y el público del museo.',
    items: ['Visitas acompañadas por música.', 'Conciertos vinculados a exposiciones.', 'Actividades familiares.', 'Experiencias sensoriales.', 'Programaciones nocturnas.', 'Propuestas educativas.'],
    cta: 'Dale otra lectura a tu espacio',
  },
  {
    id: 'estadios', tag: 'La experiencia empieza antes', title: 'Estadios y fan zones', img: images.stadium,
    lead: 'El evento no comienza cuando empieza el partido. Comienza cuando llega el público.',
    text: 'Diseñamos activaciones musicales y de entretenimiento capaces de acompañar la energía del evento, ordenar los tiempos y mantener al público conectado.',
    items: ['Fan zones.', 'Música en directo.', 'Presentadores y animación.', 'Actividades participativas.', 'Programaciones previas y posteriores.', 'Experiencias para patrocinadores.', 'Acciones familiares.'],
    cta: 'Activa la experiencia completa',
  },
  {
    id: 'instituciones', tag: 'La cultura también construye comunidad', title: 'Instituciones y ayuntamientos', img: images.openair,
    lead: 'Una plaza puede ser mucho más que el lugar donde ocurre algo.',
    text: 'Diseñamos programaciones culturales y musicales capaces de adaptarse a cada municipio, calendario y contexto. Desde una actividad concreta hasta ciclos que construyen continuidad y personalidad.',
    items: ['Ciclos musicales.', 'Festivales.', 'Programaciones de temporada.', 'Actividades familiares.', 'Propuestas didácticas.', 'Celebraciones populares.', 'Dinamización de plazas y espacios públicos.'],
    cta: 'Haz que la cultura encuentre su lugar',
  },
  {
    id: 'empresas', tag: 'Salir del formato previsto', title: 'Empresas y eventos corporativos', img: images.stageRed,
    lead: 'No todos los eventos corporativos tienen que parecerse.',
    text: 'La música y el entretenimiento ayudan a marcar el tono, conectar a las personas y convertir el evento en algo que se recuerda por lo que hizo sentir.',
    items: ['Celebraciones corporativas.', 'Presentaciones de producto.', 'Convenciones.', 'Encuentros internos.', 'Experiencias para clientes.', 'Música para recepciones y cenas.', 'Producciones completas.'],
    cta: 'Dale identidad a tu próximo encuentro',
  },
  {
    id: 'salas', tag: 'Una programación cuenta quién eres', title: 'Salas y espacios culturales', img: images.crowd2,
    lead: 'No se trata de llenar fechas. Se trata de construir una línea que el público pueda reconocer.',
    text: 'Diseñamos ciclos y programaciones capaces de combinar estilos, formatos y públicos sin perder la personalidad del espacio.',
    items: ['Programación estable.', 'Ciclos temáticos.', 'Nuevos formatos.', 'Producciones especiales.', 'Propuestas para públicos diferentes.', 'Coordinación artística y técnica.'],
    cta: 'Construye una programación con identidad',
  },
];

// ---- Hazlo posible (servicios) ----
export const serviceBlocks = [
  { n: '01', title: 'Escuchar', sub: 'Antes de proponer', text: 'Empezamos por entender: qué espacio es, quién lo visita, qué quiere conseguir, qué recursos tiene y qué debería sentir el público cuando todo termine. No llegamos con una solución preparada. Llegamos con preguntas.' },
  { n: '02', title: 'Diseñar', sub: 'Dar forma a la idea', text: 'Elegimos lo que encaja, no lo que simplemente está disponible. Definimos el formato, el tono, los contenidos y los profesionales que mejor responden al proyecto. Cada decisión nace del espacio, del público y del objetivo.' },
  { n: '03', title: 'Coordinar', sub: 'Conectar todas las piezas', text: 'Coordinamos artistas, técnicos, proveedores, horarios, accesos, necesidades de sonido, montaje y producción. Anticipamos puntos críticos y mantenemos una visión completa del proyecto.' },
  { n: '04', title: 'Activar', sub: 'El momento de hacerlo real', text: 'Supervisamos la ejecución, acompañamos a los equipos y respondemos ante los imprevistos sin trasladar la tensión al cliente ni al público. Producir es saber mantener el rumbo cuando la realidad obliga a mover una pieza.' },
];

export const clientGains = [
  'Una propuesta pensada para su espacio.',
  'Criterio para elegir.',
  'Acceso a profesionales de confianza.',
  'Coherencia entre idea y producción.',
  'Seguimiento durante todo el proceso.',
  'Capacidad para adaptarse.',
  'Tiempo para centrarse en su organización.',
];

// ---- En movimiento (proyectos) ----
export const projectCases = [
  { title: 'Un espacio público que necesitaba continuidad', need: 'Crear una programación capaz de mantener el interés más allá de una fecha concreta.', proposal: 'Un ciclo con identidad propia, formatos diversos y una producción pensada para el entorno.', result: 'Un calendario reconocible y una relación más estable con el público.', img: images.openair },
  { title: 'Una empresa que no quería otro evento más', need: 'Crear un encuentro con personalidad, sin recurrir a una fórmula corporativa previsible.', proposal: 'Una experiencia musical diseñada alrededor del tono de la marca y del momento del evento.', result: 'Una celebración con ritmo propio y una conexión más natural entre las personas.', img: images.stageRed },
  { title: 'Un entorno deportivo que quería mantener viva la energía', need: 'Acompañar al público durante los tiempos previos y posteriores al evento principal.', proposal: 'Una activación con música, animación y contenidos para sostener la experiencia completa.', result: 'Más participación, más permanencia y una atmósfera compartida.', img: images.stadium2 },
  { title: 'Un espacio cultural que necesitaba reforzar su identidad', need: 'Dar coherencia a una sucesión de actividades dispersas.', proposal: 'Una programación construida desde el carácter del espacio, sus públicos y su calendario.', result: 'Una línea reconocible y una percepción más clara del proyecto cultural.', img: images.crowd },
];

export const projectContexts = [
  { title: 'Cultura y espacio público', text: 'Programaciones, festivales, ciclos y actividades capaces de conectar con la identidad del lugar y con quienes lo habitan.' },
  { title: 'Empresa y marca', text: 'Experiencias corporativas que construyen ambiente, acompañan un mensaje y generan una relación más humana con el público.' },
  { title: 'Deporte y afición', text: 'Fan zones, animación y propuestas musicales que amplían la experiencia antes, durante y después del evento.' },
  { title: 'Hoteles y hospitalidad', text: 'Programaciones que aportan carácter, acompañan momentos concretos y ayudan a construir una identidad reconocible.' },
  { title: 'Museos y patrimonio', text: 'Propuestas que incorporan la música como otra forma de leer, recorrer y sentir un espacio.' },
  { title: 'Educación y comunidad', text: 'Conciertos didácticos, talleres, masterclasses y proyectos que acercan la música desde la participación.' },
];

// ---- Detrás del escenario (nosotros) ----
export const aboutRoles = ['Músico', 'Docente', 'Tour manager', 'Road manager', 'Stage manager', 'Director de producción', 'Ayudante de producción', 'Programador', 'Responsable de festivales', 'Coordinador artístico y técnico'];

export const aboutBlocks = [
  { title: 'El escenario', sub: 'Saber lo que ocurre delante', text: 'Quien ha estado sobre el escenario entiende lo que necesita un artista: los tiempos, la escucha, la concentración, la relación con el público y la diferencia entre sentirse acompañado o simplemente contratado.' },
  { title: 'La producción', sub: 'Saber lo que sostiene la experiencia', text: 'Detrás de cada momento fluido hay decisiones que alguien tuvo que tomar. La producción consiste en mantener una visión completa del proyecto y saber cómo afecta cada decisión al resultado final.' },
  { title: 'La docencia', sub: 'Escuchar también se aprende enseñando', text: 'Dirigir escuelas, enseñar batería y participar en proyectos pedagógicos aporta una manera distinta de trabajar: escuchar antes de intervenir, detectar necesidades y acompañar procesos.' },
  { title: 'La programación', sub: 'Elegir forma parte del proyecto', text: 'Programar no es llenar un calendario. Es construir una línea, entender qué encaja y qué personalidad debe tener el conjunto. Pensar en continuidad, equilibrio e identidad.' },
];

// ---- Hablemos (contacto) ----
export const spaceOptions = ['Hotel', 'Museo', 'Estadio o fan zone', 'Institución o ayuntamiento', 'Empresa', 'Sala o espacio cultural', 'Plaza o espacio abierto', 'Centro comercial', 'Proyecto educativo', 'Otro'];

export const contactSteps = [
  { n: '01', text: 'Leemos tu mensaje.' },
  { n: '02', text: 'Te contactamos.' },
  { n: '03', text: 'Entendemos el espacio y los objetivos.' },
  { n: '04', text: 'Preparamos una primera dirección de trabajo.' },
];
